import { render, staticRenderFns } from "./oddsColumnItem.vue?vue&type=template&id=750a1d54&lang=pug&"
import script from "./oddsColumnItem.vue?vue&type=script&lang=js&"
export * from "./oddsColumnItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports